import React, {useState, useRef, useEffect} from 'react';

function ContactForm() {

  const [nombre, setNombre] = useState('');
  const [email, setEmail] = useState('');
  const [asunto, setAsunto] = useState('');
  const [mensaje, setMensaje] = useState('');  

  const emailRef = useRef();

  useEffect(() => {
    setNombre(window.reactConfig.nombre);
    setEmail(window.reactConfig.email);
    setAsunto(window.reactConfig.asunto);
    setMensaje(window.reactConfig.mensaje);
  },[]);

  function validar_email(valor)
  {      
    // eslint-disable-next-line no-useless-escape
    if (! /^[a-z0-9][a-z0-9_.%-]+@[a-z0-9_\[\]-]+.[a-z0-9_\[\]-]+/i.test(valor)) 
    {
        return false;
    }
    
    return true;
  }

  function validar_form(e)    
  {          
    if( !validar_email(email) ) 
    {
  
      if(window.reactConfig.idioma==="_IA")
      {
        alert ('Ingrese una direccion de e-mail valida: ' + email);
      }
      else
      {
        alert ('Enter a valid  e-mail address: ' + email);
      }	
  
      emailRef.current.focus();
      emailRef.current.select();

      e.preventDefault();
  
      return false;
    }

    // console.log(nombre, email, asunto, mensaje);
      
    return true; 
  }

  

  return (
    <>
      <form name="formcont" method="post" onSubmit={ validar_form }> 
        <input type="hidden" name="valida" value="1" />
            <table border="0" align="center" width="100%">
              <tbody>
							<tr>
								<td className="main" width="30%">
                  {
                    window.reactConfig.idioma === "_IA" 
                    ?                  
                    'Nombre'
										:
                    'Name'
                  }	
                
								</td>
								<td>
									<input className="link" type="text" name="nombre" value={nombre} size="30" required onChange={e => setNombre(e.target.value)}/>
								</td>
							</tr>
							<tr>
								<td className="main">
									e-mail
								</td>
								<td>
									<input className="link" type="text" name="email" ref={emailRef} size="30" required value={email} onChange={e => setEmail(e.target.value)} />
								</td>
							</tr>
							<tr>
								<td className="main">
									{
                    window.reactConfig.idioma === "_IA"
										?
											'Asunto'
										:										
											'Subject'
                  }	
									 
								</td>
								<td>
									<input className="link" type="text" name="asunto" size="30" required value={asunto} onChange={e => setAsunto(e.target.value)} />
								</td>
							</tr>
              <tr>
                  <td colSpan="2">                    
                    { window.reactConfig.msg_error }
                  </td>
              </tr>
							<tr>
								<td className="main"  valign="top">									 
                  { window.reactConfig.idioma==="_IA" ? 'Mensaje' : 'Message' }
								</td>

								<td className="main"  >
									<textarea className="link" rows="5" cols="40" name="mensaje" required value={mensaje} onChange={e => setMensaje(e.target.value)}>
                  </textarea>
								</td>
							</tr>
              <tr>
                  <td className="main">Captcha</td>
                  <td>
                      <div className="g-recaptcha" data-sitekey={ window.reactConfig.mysite_key }></div>
                  </td>
              </tr>
							<tr>
								<td colSpan="2" className="tabla" height="2">
								</td>
							</tr>
							<tr>
								<td colSpan="2" align="center" >
                    <input className="tabla" type='submit' value={ window.reactConfig.idioma === "_IA" ? 'Enviar' : 'Submit' } name='enviar' />                    
								</td>
							</tr>
              </tbody>
						</table>
					</form>
        </>
  );
}

export default ContactForm;
